import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import Renderdevice from "./rendergroup";
import "./../../register.css";
import { getEquipment, getGrouplist } from "./../../services/fire";
import BranchContext from "../context/branch";
import Select from "../common/selectcustom";
import Input from "../common/inputfunction";
import FontAwesome from "react-fontawesome";
import ModalAddItem from "./addgroup";
import Header from "./header";
// import HeaderGroup from "./headergroupdevice";
import ScrollToTop from "../common/ScrollToTop";
import ProgressBar from "../common/progressbar";
const AddnewUser = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-4  col-sm-6 col-xs-12">
          <div className="form-group">
            <div className="from-group">
              <label htmlFor="devicename">ชื่อ-รหัสพนักงาน </label>
              <div className="input-group">
                <input
                  id="devicename"
                  name="devicename"
                  type="text"
                  placeholder="รหัส/ชื่อ เพื่อค้นหา"
                  className="form-control"
                  defaultValue
                />

                <div className="input-group-addon input-group-button col-auto  px-1">
                  <button
                    type="button"
                    id="show-contact-modal-button"
                    className="btn btn-primary"
                  >
                    ค้นหา
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="container-fluid">
          <div className="card border-secondary m-1">
            <div className="card-body">
              <div className="row">
                <div className="container col-xs-12 col-sm-6">
                  <div
                    className="border border-top-0 border-right-0 border-left-0"
                    style={{ fontSize: 15 }}
                  >
                    <span className="badge badge-pill badge-secondary">1</span>
                  </div>
                  <div
                    className="border border-top-0 border-right-0 border-left-0"
                    style={{ fontSize: 14 }}
                  >
                    {" "}
                    รหัสพนักงาน: 102
                  </div>
                  <div
                    className="border border-top-0 border-right-0 border-left-0"
                    style={{ fontSize: 14 }}
                  >
                    ชื่อ: ทรงกลด สินธุวงศานนท์
                  </div>
                  <div
                    className="border border-top-0 border-right-0 border-left-0"
                    style={{ fontSize: 15 }}
                  >
                    แผนก :Engineering Maintenance (EM)
                  </div>
                  <div
                    className="border border-top-0 border-right-0 border-left-0"
                    style={{ fontSize: 15 }}
                  >
                    เบอร์โทร :085-8354556
                  </div>
                </div>
                <div className="container col-xs-12 col-sm-6">
                  <div
                    className="border border-top-0 border-right-0 border-left-0"
                    style={{ fontSize: 14 }}
                  >
                    <div className="col-sm-6 my-1">
                      <div>
                        <div>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="102power"
                              disabled
                              defaultChecked
                              style={{ cursor: "pointer" }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="102power"
                              style={{ cursor: "pointer" }}
                            >
                              สิทธิกลุ่ม Pulp
                            </label>
                          </div>
                        </div>
                        <div>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="102power"
                              disabled
                              defaultChecked
                              style={{ cursor: "pointer" }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="102power"
                              style={{ cursor: "pointer" }}
                            >
                              สิทธิกลุ่ม Power
                            </label>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  
                  <div
                    className="border border-top-0 border-right-0 border-left-0"
                    style={{ fontSize: 14 }}
                  >
                    <div className="col-sm-6 my-1">
                      <div>
                        <div>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="102non"
                              disabled
                              defaultChecked
                              style={{ cursor: "pointer" }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="102non"
                              style={{ cursor: "pointer" }}
                            >
                              ดูรายงาน{" "}
                            </label>
                          </div>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="102non"
                              disabled
                              defaultChecked
                              style={{ cursor: "pointer" }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="102non"
                              style={{ cursor: "pointer" }}
                            >
                              ดูรายงาน{" "}
                            </label>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="input-group-addon input-group-button col-auto  px-1">
                  <button
                    type="button"
                    id="show-contact-modal-button"
                    className="btn btn-primary"
                  >
                    บันทึก
                  </button>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="col-sm-6 col-xs-12">
    <div className="form-group">
        <label htmlFor="item">รหัสพนักงาน</label>
        <input 
        // placeholder="=ชื่อ" 
        id="item" 
        name="item" 
        type="text" 
        defaultValue />
        </div>
        </div> */}
    </div>
  );
};

export default AddnewUser;
